import { IconButton, withStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { connect } from "react-redux";
import { injectStripe } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import { placeOrderAction, upgradePlan, counterpartyOrder } from "../../../modules/billing/action";
import { logout } from "../../../modules/user/redux/action";
import PaymentForm from "../../public/Checkout/PaymentForm";



const closeButtonStyle = {
  position: "absolute",
  right: 2,
  top: 2
};

const useStyles = theme => ({
  appBar: {
    position: "relative"
  },
  layout: {
    width: "auto",
    margin: 16,
    width: "95%"
  },
  paper: {
    marginTop: 4,
    marginBottom: 4,
    padding: 16
  },
  stepper: {
    padding: "24px 0px 40px"
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    marginTop: 24,
    marginLeft: 8
  }
});

const errorHeader = "We regret to inform you that order could not be completed";

class UpgradePlanPayment extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.classes = useStyles();
    this.state = {
      isDisabled: false,
      username: userDetail() ? userDetail().username : "",
      firstName: userDetail() ? userDetail().firstName : "",
      lastName: userDetail() ? userDetail().lastName : "",
      town: userDetail() ? userDetail().town : "",
      state: userDetail() ? userDetail().state : "",
      country: userDetail() ? userDetail().country : "",
      zipCode: userDetail() ? userDetail().zipCode : "",
      streetAddress: userDetail() ? userDetail().streetAddress : "",
      contactNo: userDetail() ? userDetail().contactNo : "",
      showSuccess: false,
      showError: false
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.isFetchingComplete !== nextProps.isFetchingComplete &&
      nextProps.isFetchingComplete
    ) {
      if (nextProps.isError) {
        this.setState({ showError: true });
      } else {
        this.setState({ showSuccess: true });
      }
    }
  };

  handleChange = input => e => {
    if (!this.state.edited) this.setState({ edited: true });
    const value = e.target.value;
    if (input === "contactNo") {
      if (value.match(/^\d{0,15}?$/)) {
        this.setState({ [input]: value });
      }
    } else this.setState({ [input]: value });
  };

  async submit(ev) {
    this.setState({
      isDisabled: true,
      edited: false
    });
    const { cartList, username, lastName, firstName, contactNo } = this.state;
    const { planId, currentPlanId, isCounterParty } = this.props;
    const { state, streetAddress, town, zipCode } = this.state;
    const address = { state, streetAddress, town, zipCode };

    let { token } = await this.props.stripe.createToken({ name: "Name" });

    if (token) {
      const requestData = {
        planId,
        sourceToken: token.id,
        username
      };
      if (currentPlanId === 1) {
        if(isCounterParty){
          const {username} = this.props.tokenDetails || ''
          this.props.counterpartyOrder({sourceToken: token.id,username:username || userDetail().username})
        }
        else{
        this.props.placeOrderAction(requestData);
        }
      } else {
        this.props.upgradePlan(requestData);
      }
      console.log(this.props.isError, this.props.error);
      console.log(requestData);
    } else {
      this.setState({
        isDisabled: false
      });
      alert("Please enter valid card information");
    }
  }

  render() {
    const {isCounterParty} = this.props;
    const { firstName, lastName, cartList, cardHolderName } = this.state;
    const values = {
      firstName,
      lastName,
      cartList,
      cardHolderName
    };

    return (
      <Dialog
        open={true}
        fullWidth={true}
        maxWidth={"md"}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          {this.state.showError
            ? "Payment Failed"
            : this.state.showSuccess
            ? "Payment Successful"
            : "Proceed for payment"}
         {(!isCounterParty || this.state.showSuccess ) && <IconButton
            aria-label="Close"
            style={closeButtonStyle}
            onClick={isCounterParty ?this.props.handleredirectionClode : this.props.handleClose }
          >
            <CloseIcon />
          </IconButton>}
        </DialogTitle>
        {this.state.showError ? (
          <DialogContent>
            <Typography
              variant="h6"
              gutterBottom
              style={{ pointerEvents: "none" }}
            >
              {errorHeader}
            </Typography>
            <Typography variant="subtitle1" style={{ marginLeft: "12px" }}>
              {this.props.error && this.props.error.split(";")[0]}
            </Typography>
            {isCounterParty&&
            <div style={{display:'flex',justifyContent:'end',width:'100%'}}>
              <button className="element_button" onClick={()=>window.location.reload()}>Retry</button>
            </div> }
          </DialogContent>
        ) : this.state.showSuccess ? (
          <DialogContent>
            <React.Fragment>
              <Typography variant="h6" gutterBottom style={{ pointerEvents: "none" }}>
             {isCounterParty?'You have completed your payment':`Your account has been upgraded to ${this.props.newPlanName} plan`}           
              </Typography>
            </React.Fragment>
            {isCounterParty  &&
            <div style={{display:'flex',justifyContent:'end',width:'100%'}}>
            <button
            className="element_button"
            aria-label="Close"
            onClick={this.props.handleredirectionClode}
          >
            Continue
          </button>
          </div>}
          </DialogContent>
        ) : (
          <DialogContent>
            <DialogContentText style={{ fontSize: 16 }}>
              {`${this.props.currency} ${this.props.amount} will be deducted from your account`}
            </DialogContentText>
            <br />
            <PaymentForm
              values={values}
              handleChange={this.handleChange}
              handleSubmit={this.submit}
              btnLabel={"Proceed to checkout"}
              isDisabled={this.state.isDisabled}
            />
          </DialogContent>
        )}
      </Dialog>
    );
  }
}
const mapStateToProps = state => {
  return {
    isError: state.billingReducer.isError,
    error: state.billingReducer.error,
    isFetchingComplete: state.billingReducer.isFetchingComplete,
    subscriptionData: state.billingReducer.subscriptionData,
    tokenDetails:state.subscriptionList.tokenDetails
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ upgradePlan, placeOrderAction,counterpartyOrder, logout }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(injectStripe(UpgradePlanPayment)));



// WEBPACK FOOTER //
// ./src/components/private/Billing/UpgradePlanPayment.js